import { CanActivate } from '@angular/router'
import { Injectable } from '@angular/core'
import { AuthRedirectService, AuthService, BaseSiteService, } from '@spartacus/core'
import { map, switchMap, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbGuestMyAccountPagesGuard implements CanActivate {

  supportsAccountCreation: boolean | undefined

  constructor (protected authService: AuthService,
               protected authRedirectService: AuthRedirectService,
               protected baseSiteService: BaseSiteService,) {
  }

  canActivate () {
    // redirect, if user is already logged in:
    return this.baseSiteService.get().pipe(
      tap(baseSite => this.supportsAccountCreation = baseSite?.supportingAccountCreation || false),
      switchMap(() => this.authService.isUserLoggedIn()),
      map(isLoggedIn => {
        if (isLoggedIn) {
          return this.supportsAccountCreation || false
        } else {
          if (this.supportsAccountCreation) {
            this.authRedirectService.saveCurrentNavigationUrl()
            this.authService.loginWithRedirect()
          }
          return false
        }
      })
    )
  }
}
